<app-action-form [item]="item" [slot]="slot" [form]="form">
	<div class="form-section app-margin-horizontal app-padding">
    <div class="form-group" [formGroup]="form">
        <app-unit-quantity label="Percentage given" unitLabel="&percnt;" placeholder="Value" inputMode="decimal" formControlName="percentageGiven"></app-unit-quantity>
    </div>
    <app-common-action-controls [action]="action" [form]="form"></app-common-action-controls>
  </div>
</app-action-form>

